<template>
	<v-col class="detail-message">
		<div v-if="!loading">
			<v-card class="pa-3 elevation-0 rounded-lg" v-if="Object.keys(detailMessage).length > 0">
				<div class="d-flex">
					<div>
						<v-btn fab x-small depressed color="primary" @click="goBack">
							<v-icon>mdi-arrow-left</v-icon>
						</v-btn>
					</div>
					<div class="pl-3 text-h6 cl-primary">Detail Pesan Terkirim</div>
				</div>
				<div class="pt-5">
					<div class="font-size-11 font-weight-bold">{{ detailMessage.message_sender_name }}</div>
					<div class="d-sm-flex justify-space-between">
						<div class="font-size-9 cl-grey">Kepada {{ detailMessage.message_receive_name }}</div>
						<div class="font-size-9">{{ detailMessage.message_datetime | tanggaljam }}</div>
					</div>
				</div>
				<div class="pt-3">
					<div class="font-size-11" v-html="detailMessage.message_content"></div>
				</div>
			</v-card>
			<div v-else>
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
							<v-img eager class="mx-auto" width="180" height="180" src="/assets/icon/empty-message.png"></v-img>
							<div class="pt-3 text-center cl-secondary">Tidak ada pesan yang dapat ditampilkan</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
		</div>
		<div v-if="loading">
			<v-row>
				<v-col cols="12" sm="12" md="12">
					<LoadData :loading="loading"></LoadData>
				</v-col>
			</v-row>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
		}
	},
	computed: {
		...mapState('message', ['detailMessage']),
	},
	methods: {
		...mapActions('message', ['getDetailMessage']),

		getData() {
			this.loading = true
			let id = this.$route.params.id
			this.getDetailMessage({id: id}).then(() => {
				this.loading = false
			}).catch(() => {
				this.loading = false
			})
		},
		goBack() {
			this.$router.push({ name: 'pesan-terkirim' })
		}
	},
	created(){
		this.$store.dispatch('setPageTitle', `Detail Pesan Terkirim`)
		this.getData()
	}
};
</script>